<template>
    <div class="appVersion">
<!--        <div class="header">-->
<!--            <div class="title">角色管理</div>-->
<!--        </div>-->
        <div>
            <form :form="form" @submit.prevent="query">
                <div style="display: flex;justify-content: space-between;align-items: center;">
                    <div class="logQuery">
                        <InputField labelWidth="40%" style="margin: 0.5rem 0.2rem;width:30%" label="编码" type="text" id="code"
                                    :modelValue="form.code" placeholder="请输入编码"
                                    @update:modelValue="(value) => handleModelValueUpdate('code', value)"
                        />
                        <InputField labelWidth="30%" style="margin: 0.5rem 0.2rem;width:30%" label="姓名" type="text" id="name"
                                    :modelValue="form.name" placeholder="请输入姓名"
                                    @update:modelValue="(value) => handleModelValueUpdate('name', value)"
                        />
                        <a-space style="margin: 0 0 0 0.5rem">
                            <ButtonField text="查询" @click="query" secondary />
                            <ButtonField text="重置" primary @click="reset"/>
                        </a-space>
                    </div>
                    <div class="right">
                        <ButtonField text="新增" primary @click="$router.push('/setting/role/add')" />
                    </div>
                </div>
            </form>
        </div>
        <div>
            <Tablelist :showCheckbox="false"
                       :list="list"
                       :columns="tableColumns"
                       :totalSize="totalSize"
                       :totalPages="totalPages"
                       :pageNum="pageNum"
                       :pageSize="pageSize">
                <template v-slot:actions="{ item }">
                    <a-space>
                        <a href="#" @click.prevent="$router.push('/setting/role/edit?id=' + item.id)">编辑</a>
                        <a href="#" class="danger" @click.prevent="deleteText(item)">删除</a>
                    </a-space>
                </template>
            </Tablelist>
        </div>
        <Modal v-if="addShow" :modelValue="addShow"
               contentWidth="1200px"
               :visible="addShow" :title="'选择资产'" :showFooter="false" :overlayOpacity="0.5"
               @update:visible="addShow = $event">
            <RoleIndex v-if="addShow" @cancel="handleCancel"/>
        </Modal>
    </div>
</template>

<script>
import { fetchList, remove } from "@/api/setting/role";
import RoleIndex from "@/views/setting/role/add.vue";
export default {
  components: { RoleIndex},
  data() {
    return {
      form: {},
      loading: false,
      totalSize: 1,
      totalPages: 1,
      pageNum: 1,
      pageSize: 10,
      list: [],
      total: 0,
      addShow:false,
      visible:false,
      tableColumns: [
            {
                key: 'code',
                title: '编码',
                field: 'code',
                infotype: 'text'
            },
            {
                key: 'name',
                title: '名称',
                field: 'name',
                infotype: 'text'
            },
          {
              key: 'remarks',
              title: '描述',
              field: 'remarks',
              infotype: 'text'
          },
          {
              key: 'actions',
              title: '操作',
              infotype:'template'
          }
        ],
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    handleCancel(visible){
        this.addShow = visible;
    },
    handleModelValueUpdate(fieldName, value) {
        this.form[fieldName] = value;
    },
    handleAction(actionInfo){
        const { type, item,action } = actionInfo;
        console.log("action:::",action)
        switch(type) {
          case 'edit':
              this.editText(item);
              break;
          case 'delete':
              this.deleteText(item);
              break;
        }
    },
    editText(text){
      this.$router.push('/setting/role/edit?id=' + text.id);
    },
    add(){
        console.log("this.addShow:::",this.addShow)
        this.addShow = !this.addShow
    },
    getList() {
      this.loading = true;
      fetchList({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        ...this.form,
      })
        .then((res) => {
          if (Array.isArray(res.list)) {
            this.list = Object.freeze(res.list);
            this.totalSize = res.totalSize;
            this.totalPages = res.totalPages;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    deleteText(text) {
      const that = this;

      this.$confirm({
        title: "确认要删除吗？",
        onOk() {
          remove({ id: text.id }).then(() => {
            that.getList();
          });
        },
      });
    },

    onChange(pagination) {
      this.current = pagination.current;
      this.getList();
    },

    query() {
      this.current = 1;
      this.getList();
    },
    reset() {
      this.form = {};
      this.current = 1;
      this.getList();
    },
  },
};
</script>
<style scoped>
.logQuery{
    display: flex;
    justify-content: start;
    width: 70%;
}
::v-deep .input-container{
    padding: 0;
}
</style>